 function findCountry(countryName, countries) {
    const foundCountry = countries
    .filter((el) => el.name.toLowerCase().includes(countryName.toLowerCase()))
    .map(el => {
        return {label: el.name, countryCode: el.code}
    });

    return foundCountry;

}


 function getCityName(cityObject) {
    const cityName = cityObject?.cityName;
    const labelShort = cityObject?.labelShort;
    const zipCode = cityObject?.zipCode;

    if(cityName) {
        return cityName;
    }


    if(zipCode && zipCode.length > 0) {
        return labelShort.split(zipCode)[0].trim()
    }

    if(!cityName) {
        return labelShort.trim();
    }

    if(zipCode && zipCode.length === 0) {
        return ''
    }
}

function getProvinceName(cityObject) {
    const cityName = cityObject?.cityName;
    const provinceCode = cityObject?.provinceCode;
    if(cityName) {
        return provinceCode;
    }

    if(!cityName && provinceCode) {
        return provinceCode;
    }

    if(!cityName && !provinceCode) {
        return '';
    }
}

function getZipCode(cityObject) {
    const cityName = cityObject?.cityName;
    const provinceCode = cityObject?.provinceCode;
    const zipCode = cityObject?.zipCode;

    if(cityName) {
        return zipCode;
    }

    if(!cityName && zipCode) {
        return zipCode;
    }

    if(!cityName && !provinceCode) {
        return '';
    }
}

function togglePropertyField({ items, fieldName, booleanValue, propertyName}) {
    const foundItem = items.find(item => item.id === fieldName);
    const foundItemIndex = items.findIndex(item => item.id === fieldName);
    foundItem[propertyName] = booleanValue;
    items[foundItemIndex] = foundItem;
}

function  resetCityProvinceZipField(items) {
    items.forEach((item => {
        if (item.id === 'city') {
            item.value = '';
        }else if (item.id === 'province') {
            item.value = '';
        }else if (item.id === 'zip') {
            item.value = '';
        }
    }));
}



export {
    findCountry,
    getCityName,
    getProvinceName,
    getZipCode,
    togglePropertyField,
    resetCityProvinceZipField
}